import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getActivityStatusList as getActivityStatusListApi } from '../../helpers/activity_status/api_helper';

export const getActivityStatusList = createAsyncThunk(
    'activityStatus/getActivityStatusList',
    async params => {
        try {
            const response = await getActivityStatusListApi(params);
            return response.data || response;
        } catch (error) {
            toast.error('Error al obtener estados de actividad.', { autoClose: 3000 });
            throw new Error(error);
        }
    }
);
